import { buildAxiosClient } from '../axiosClient';
import type { AxiosPromise } from 'axios';
import type { Bank } from './bank';
import type { BankBranch } from './bankBranch';

export default class BankClient {
  fetchAll(): AxiosPromise<Array<Bank>> {
    return buildAxiosClient().get('/api/v1/banks.json');
  }

  fetchBranches(bankId: number): AxiosPromise<Array<BankBranch>> {
    return buildAxiosClient().get('/api/v1/bank_branches.json', {
      params: {
        bank_id: bankId,
      },
    });
  }
}
